// Mock repository data matching the database schema
// This will be replaced with API calls later

export const mockRepositories = [
  {
    id: '1',
    slug: 'fender-twin-reverb',
    title: 'Fender Twin Reverb',
    description: 'Classic tube amplifier schematic with full component layout and wiring diagrams. Includes both original 1960s and reissue versions.',
    owner: {
      id: 'user-1',
      username: 'amp_restorer',
      avatar_url: null
    },
    visibility: 'public',
    manufacturer: 'Fender',
    model_number: 'Twin Reverb',
    device_type: 'amplifier',
    form_factor: 'console',
    year: 1965,
    known_revisions: ['Blackface', 'Silverface', 'Reissue'],
    readme_content: '# Fender Twin Reverb\n\nClassic Fender amplifier schematic...',
    tags: ['tube', 'vintage', 'fender', 'reverb', 'twin'],
    category: 'Amplifiers',
    keywords: ['fender', 'twin', 'reverb', 'tube', 'amplifier', 'vintage'],
    pinned_file_ids: [],
    license: {
      id: 'license-1',
      name: 'CC-BY-4.0',
      slug: 'cc-by-4.0'
    },
    version_count: 3,
    commit_count: 12,
    branch_count: 2,
    latest_commit: {
      id: 'commit-1',
      message: 'Add Silverface revision schematic',
      author: 'amp_restorer',
      created_at: '2024-12-15T10:30:00Z'
    },
    created_at: '2024-01-15T08:00:00Z',
    updated_at: '2024-12-15T10:30:00Z'
  },
  {
    id: '2',
    slug: 'moog-minimoog',
    title: 'Moog Minimoog',
    description: 'Legendary analog synthesizer with complete circuit analysis. Includes oscillator, filter, and envelope generator schematics.',
    owner: {
      id: 'user-2',
      username: 'synth_archivist',
      avatar_url: null
    },
    visibility: 'public',
    manufacturer: 'Moog',
    model_number: 'Minimoog Model D',
    device_type: 'synthesizer',
    form_factor: 'desktop',
    year: 1971,
    known_revisions: ['Model D', 'Reissue'],
    readme_content: '# Moog Minimoog\n\nComplete schematic documentation...',
    tags: ['analog', 'synthesizer', 'moog', 'vintage', 'monophonic'],
    category: 'Synthesizers',
    keywords: ['moog', 'minimoog', 'synthesizer', 'analog', 'vintage'],
    pinned_file_ids: [],
    license: {
      id: 'license-2',
      name: 'MIT License',
      slug: 'mit'
    },
    version_count: 5,
    commit_count: 28,
    branch_count: 3,
    latest_commit: {
      id: 'commit-2',
      message: 'Update filter section with component values',
      author: 'synth_archivist',
      created_at: '2024-12-20T14:15:00Z'
    },
    created_at: '2024-02-10T09:00:00Z',
    updated_at: '2024-12-20T14:15:00Z'
  },
  {
    id: '3',
    slug: 'boss-ds-1',
    title: 'Boss DS-1',
    description: 'Iconic distortion pedal schematic with component analysis. One of the most popular guitar pedals ever made.',
    owner: {
      id: 'user-3',
      username: 'pedal_tech',
      avatar_url: null
    },
    visibility: 'public',
    manufacturer: 'Boss',
    model_number: 'DS-1',
    device_type: 'effect',
    form_factor: 'pedal',
    year: 1978,
    known_revisions: ['Original', 'MIT', 'Taiwan'],
    readme_content: '# Boss DS-1\n\nDistortion pedal schematic...',
    tags: ['distortion', 'pedal', 'boss', 'guitar', 'effect'],
    category: 'Effects',
    keywords: ['boss', 'ds-1', 'distortion', 'pedal', 'guitar'],
    pinned_file_ids: [],
    license: {
      id: 'license-3',
      name: 'CC-BY-SA-4.0',
      slug: 'cc-by-sa-4.0'
    },
    version_count: 2,
    commit_count: 8,
    branch_count: 1,
    latest_commit: {
      id: 'commit-3',
      message: 'Add component value annotations',
      author: 'pedal_tech',
      created_at: '2024-12-18T11:20:00Z'
    },
    created_at: '2024-03-05T10:00:00Z',
    updated_at: '2024-12-18T11:20:00Z'
  },
  {
    id: '4',
    slug: 'roland-juno-60',
    title: 'Roland Juno-60',
    description: 'Classic polyphonic synthesizer with DCO and chorus circuit documentation.',
    owner: {
      id: 'user-1',
      username: 'amp_restorer',
      avatar_url: null
    },
    visibility: 'public',
    manufacturer: 'Roland',
    model_number: 'Juno-60',
    device_type: 'synthesizer',
    form_factor: 'desktop',
    year: 1982,
    known_revisions: ['Original'],
    readme_content: '# Roland Juno-60\n\nPolyphonic synthesizer schematic...',
    tags: ['synthesizer', 'roland', 'polyphonic', 'dco', 'vintage'],
    category: 'Synthesizers',
    keywords: ['roland', 'juno-60', 'synthesizer', 'polyphonic'],
    pinned_file_ids: [],
    license: {
      id: 'license-1',
      name: 'CC-BY-4.0',
      slug: 'cc-by-4.0'
    },
    version_count: 1,
    commit_count: 5,
    branch_count: 1,
    latest_commit: {
      id: 'commit-4',
      message: 'Initial schematic upload',
      author: 'amp_restorer',
      created_at: '2024-12-10T09:00:00Z'
    },
    created_at: '2024-12-10T09:00:00Z',
    updated_at: '2024-12-10T09:00:00Z'
  },
  {
    id: '5',
    slug: 'neve-1073',
    title: 'Neve 1073',
    description: 'Professional microphone preamplifier and equalizer module. Industry standard for recording studios.',
    owner: {
      id: 'user-4',
      username: 'studio_engineer',
      avatar_url: null
    },
    visibility: 'unlisted',
    manufacturer: 'Neve',
    model_number: '1073',
    device_type: 'mixer',
    form_factor: 'rack',
    year: 1970,
    known_revisions: ['Original', 'Reissue'],
    readme_content: '# Neve 1073\n\nProfessional preamp schematic...',
    tags: ['preamp', 'neve', 'professional', 'rack', 'eq'],
    category: 'Mixers',
    keywords: ['neve', '1073', 'preamp', 'eq', 'professional'],
    pinned_file_ids: [],
    license: {
      id: 'license-2',
      name: 'MIT License',
      slug: 'mit'
    },
    version_count: 4,
    commit_count: 15,
    branch_count: 2,
    latest_commit: {
      id: 'commit-5',
      message: 'Add EQ section detail',
      author: 'studio_engineer',
      created_at: '2024-12-22T16:45:00Z'
    },
    created_at: '2024-04-20T12:00:00Z',
    updated_at: '2024-12-22T16:45:00Z'
  },
  {
    id: '6',
    slug: 'moog-mother-32',
    title: 'Moog Mother-32',
    description: 'Semi-modular synthesizer with patch bay documentation and circuit analysis.',
    owner: {
      id: 'user-2',
      username: 'synth_archivist',
      avatar_url: null
    },
    visibility: 'public',
    manufacturer: 'Moog',
    model_number: 'Mother-32',
    device_type: 'synthesizer',
    form_factor: 'modular',
    year: 2015,
    known_revisions: ['Original'],
    readme_content: '# Moog Mother-32\n\nSemi-modular synthesizer...',
    tags: ['moog', 'synthesizer', 'modular', 'semi-modular', 'modern'],
    category: 'Synthesizers',
    keywords: ['moog', 'mother-32', 'synthesizer', 'modular'],
    pinned_file_ids: [],
    license: {
      id: 'license-3',
      name: 'CC-BY-SA-4.0',
      slug: 'cc-by-sa-4.0'
    },
    version_count: 2,
    commit_count: 10,
    branch_count: 1,
    latest_commit: {
      id: 'commit-6',
      message: 'Update patch bay documentation',
      author: 'synth_archivist',
      created_at: '2024-12-19T13:30:00Z'
    },
    created_at: '2024-05-15T14:00:00Z',
    updated_at: '2024-12-19T13:30:00Z'
  }
]

// Filter options for UI
export const filterOptions = {
  manufacturers: ['Fender', 'Moog', 'Boss', 'Roland', 'Neve'],
  deviceTypes: ['amplifier', 'synthesizer', 'effect', 'mixer', 'other'],
  formFactors: ['pedal', 'rack', 'desktop', 'modular', 'console', 'other'],
  visibility: ['public', 'unlisted', 'private'],
  licenses: ['MIT License', 'CC-BY-4.0', 'CC-BY-SA-4.0', 'GPL-3.0'],
  sortOptions: [
    { value: 'newest', label: 'Newest First' },
    { value: 'oldest', label: 'Oldest First' },
    { value: 'updated', label: 'Recently Updated' },
    { value: 'name', label: 'Name (A-Z)' },
    { value: 'commits', label: 'Most Commits' }
  ]
}

